export default [
  {
    path: '/agreement/privacy',
    name: 'AgreementPrivacy',
    component: () => import(/*webpackChunkName:'AgreementPrivacy'*/ '@/views/agreement/privacy'),
    meta: { title: '隐私协议' },
  },
  {
    path: '/agreement/user',
    name: 'AgreementUser',
    component: () => import(/*webpackChunkName:'AgreementUser'*/ '@/views/agreement/user'),
    meta: { title: '使用协议' },
  },
]
